// extracted by mini-css-extract-plugin
export default {"mt":"homepagebestsellproduct_mt__1HfRg"};